/*
 * NicheCanvas — Floating Frame upsell inside the UpCart drawer.
 * Detects "Gallery Wrap" line items and offers a same size/format swap to a
 * Black/White Floating Frame. Hooks UpCart's public JS API + per-item shadow-DOM
 * anchor. Additive only — never touches UpCart add-ons (e.g. Rush Order).
 * Buttons mirror the native /cart upsell: big square frame icon (border = frame,
 * fill = canvas, NO white mat) above an "Upgrade (black/white)" label, orange CTA.
 */
(function () {
  'use strict';

  var CFG = window.NCFrameUpsell || {};
  var LABELS = CFG.labels || {};
  var MONEY_FORMAT = CFG.moneyFormat || '${{amount}}';
  var cache = {};

  function norm(s) { return (s == null ? '' : String(s)).toLowerCase().trim(); }
  function isGalleryWrap(t) { return norm(t).replace(/\s+/g, '-') === 'gallery-wrap'; }

  function formatMoney(cents) {
    cents = typeof cents === 'number' ? cents : (parseInt(cents, 10) || 0);
    function fmt(precision, thousandsSep, decimalSep) {
      var amount = (cents / 100).toFixed(precision);
      var parts = amount.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousandsSep);
      return dollars + (parts[1] ? decimalSep + parts[1] : '');
    }
    var match = MONEY_FORMAT.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = match ? match[1] : 'amount';
    var value;
    switch (key) {
      case 'amount_no_decimals': value = fmt(0, ',', '.'); break;
      case 'amount_with_comma_separator': value = fmt(2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(0, '.', ','); break;
      case 'amount_with_space_separator': value = fmt(2, ' ', ','); break;
      default: value = fmt(2, ',', '.');
    }
    return MONEY_FORMAT.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  function root() { return window.upcartDocumentOrShadowRoot || null; }

  function fetchProduct(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { if (p) cache[handle] = p; return p; })
      .catch(function () { return null; });
  }

  function findFrames(product, cur) {
    var black = null, white = null;
    product.variants.forEach(function (v) {
      if (v.available === false) return;
      if (v.option2 === cur.option2 && v.option3 === cur.option3) {
        var f = norm(v.option1);
        if (f.indexOf('floating') >= 0) {
          if (f.indexOf('black') >= 0) black = v;
          else if (f.indexOf('white') >= 0) white = v;
        }
      }
    });
    return { black: black, white: white };
  }

  function ensureStyles() {
    var r = root(); if (!r || r.querySelector('#nc-fu-style')) return;
    var st = document.createElement('style');
    st.id = 'nc-fu-style';
    st.textContent = '.nc-fu{margin:12px 0 2px;font-size:13px;line-height:1.3;}'
      + '.nc-fu__title{font-family:Poppins,"Neutrif Pro",-apple-system,sans-serif;font-weight:600;font-size:13px;color:#000;margin-bottom:2px;}'
      + '.nc-fu__label{margin-bottom:10px;opacity:.8;font-size:12px;}'
      + '.nc-fu__amt{font-weight:700;}'
      + '.nc-fu__btns{display:flex;gap:10px;}'
      + '.nc-fu__opt{flex:1;display:flex;flex-direction:column;}'
      + '.nc-fu__flag{display:block;width:100%;box-sizing:border-box;font-family:Poppins,"Neutrif Pro",-apple-system,sans-serif;font-weight:700;text-transform:uppercase;font-size:10px;letter-spacing:.08em;line-height:1;padding:5px 6px;text-align:center;border-radius:0;background:#000;color:#fff;}'
      + '.nc-fu__flag--ghost{background:transparent;color:transparent;}'
      + '.nc-fu__btn{flex:1;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:11px;background:#FF9C32;color:#000;border:0;border-radius:0;padding:14px 8px;cursor:pointer;transition:background 160ms ease;}'
      + '.nc-fu__btn:hover{background:#F58A1A;}'
      + '.nc-fu__btn:active{background:#E67A10;}'
      + '.nc-fu__btn[disabled]{opacity:.55;cursor:default;}'
      + '.nc-fu__frame{display:block;width:100%;max-width:104px;height:62px;box-sizing:border-box;background:#eee;}'
      + '.nc-fu__frame--black{border:5px solid #000;}'
      + '.nc-fu__frame--white{border:4px solid #fff;box-shadow:0 0 0 1px #ccc;}'
      + '.nc-fu__lbl{font-family:Poppins,"Neutrif Pro",-apple-system,sans-serif;font-weight:700;text-transform:uppercase;letter-spacing:.04em;font-size:13px;line-height:1.2;text-align:center;}';
    r.appendChild(st);
  }

  function doSwap(lineKey, fromVariantId, toVariantId, qty, container) {
    if (container.getAttribute('data-nc-busy')) return;
    container.setAttribute('data-nc-busy', '1');

    var lineItem = container;
    while (lineItem && !(lineItem.classList && lineItem.classList.contains('upcart-product-item'))) {
      lineItem = lineItem.parentNode;
    }
    var controlsRoot = lineItem || container;
    var qtyInput = controlsRoot.querySelector('.upcart-product-quantity-input');
    var currentQty = qtyInput ? (parseInt(qtyInput.value, 10) || qty) : qty;
    var disabledControls = [];
    Array.prototype.forEach.call(controlsRoot.querySelectorAll('button,input,select'), function (control) {
      if (control.hasAttribute('disabled')) return;
      control.setAttribute('disabled', 'disabled');
      disabledControls.push(control);
    });

    if (!window.NCCartFrameSwap || typeof window.NCCartFrameSwap.swap !== 'function') {
      container.removeAttribute('data-nc-busy');
      Array.prototype.forEach.call(disabledControls, function (control) { control.removeAttribute('disabled'); });
      if (typeof window.showUpcartErrorToast === 'function') window.showUpcartErrorToast();
      return;
    }
    window.NCCartFrameSwap.swap({
      lineKey: lineKey,
      fromVariantId: fromVariantId,
      toVariantId: toVariantId,
      quantity: currentQty
    }).then(function () {
      if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart();
    }).catch(function () {
      container.removeAttribute('data-nc-busy');
      Array.prototype.forEach.call(disabledControls, function (control) { control.removeAttribute('disabled'); });
      if (typeof window.showUpcartErrorToast === 'function') window.showUpcartErrorToast();
    });
  }

  function lblHtml(s) {
    s = String(s == null ? '' : s).trim();
    var i = s.lastIndexOf(' ');
    return i > 0 ? s.slice(0, i) + '<br>' + s.slice(i + 1) : s;
  }

  function makeButton(kind, variant, lineKey, fromVariantId, qty, container, withBadge) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'nc-fu__btn';
    b.innerHTML = '<span class="nc-fu__frame nc-fu__frame--' + kind + '"></span>'
      + '<span class="nc-fu__lbl">' + lblHtml(kind === 'black' ? (LABELS.black || 'Upgrade Black') : (LABELS.white || 'Upgrade White')) + '</span>';
    b.addEventListener('click', function () { doSwap(lineKey, fromVariantId, variant.id, qty, container); });
    if (!withBadge) return b;
    // "Most Popular" flag on black (71% of upgrades); a ghost flag on white keeps both
    // buttons the same height (in-flow, no absolute positioning, mobile-safe).
    var opt = document.createElement('div');
    opt.className = 'nc-fu__opt';
    var flag = document.createElement('span');
    if (kind === 'black') {
      flag.className = 'nc-fu__flag';
    } else {
      flag.className = 'nc-fu__flag nc-fu__flag--ghost';
      flag.setAttribute('aria-hidden', 'true');
    }
    flag.textContent = 'Most Popular';
    opt.appendChild(flag);
    opt.appendChild(b);
    return opt;
  }

  function readType(item) {
    var opts = item.querySelectorAll('.upcart-item-option');
    for (var i = 0; i < opts.length; i++) {
      if (norm(opts[i].getAttribute('data-upcart-item-option-category')) === 'type') {
        return opts[i].getAttribute('data-upcart-item-option-value');
      }
    }
    return null;
  }

  function processItem(item) {
    if (/skeleton/.test(item.className)) return;
    var anchor = item.querySelector('.upcart-item-properties-anchor-after');
    if (!anchor || anchor.querySelector('.nc-fu')) return;
    var state = item.getAttribute('data-nc-fu');
    if (state === 'pending' || state === 'none') return;
    if (!isGalleryWrap(readType(item))) return;
    var id = item.id || '';
    var variantId = id.split(':')[0];
    if (!variantId) return;
    var link = item.querySelector('a[href*="/products/"]');
    if (!link) return;
    var handle = link.getAttribute('href').split('/products/')[1].split('?')[0].split('#')[0];

    if (!window.NCCartFrameSwap || typeof window.NCCartFrameSwap.snapshot !== 'function') return;
    item.setAttribute('data-nc-fu', 'pending');
    Promise.all([
      fetchProduct(handle),
      window.NCCartFrameSwap.snapshot({ lineKey: id, fromVariantId: variantId })
    ]).then(function (results) {
      var product = results[0];
      item.removeAttribute('data-nc-fu');
      if (!product) return;
      var cur = null;
      for (var j = 0; j < product.variants.length; j++) {
        if (String(product.variants[j].id) === String(variantId)) { cur = product.variants[j]; break; }
      }
      if (!cur) return;
      var frames = findFrames(product, cur);
      var ref = frames.black || frames.white;
      if (!ref) { item.setAttribute('data-nc-fu', 'none'); return; }
      var diff = ref.price - cur.price;
      if (diff <= 0) { item.setAttribute('data-nc-fu', 'none'); return; }
      if (anchor.querySelector('.nc-fu')) return;
      var qtyInput = item.querySelector('.upcart-product-quantity-input');
      var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;

      ensureStyles();
      var wrap = document.createElement('div');
      wrap.className = 'nc-fu';
      var title = document.createElement('div');
      title.className = 'nc-fu__title';
      title.textContent = LABELS.title || 'Give it the gallery look';
      var label = document.createElement('div');
      label.className = 'nc-fu__label';
      label.innerHTML = (LABELS.intro || 'Add a floating frame for') + ' <span class="nc-fu__amt">+' + formatMoney(diff) + '</span>';
      var btns = document.createElement('div');
      btns.className = 'nc-fu__btns';
      var withBadge = !!(frames.black && frames.white);
      if (frames.black) btns.appendChild(makeButton('black', frames.black, id, variantId, qty, wrap, withBadge));
      if (frames.white) btns.appendChild(makeButton('white', frames.white, id, variantId, qty, wrap, withBadge));
      wrap.appendChild(title);
      wrap.appendChild(label);
      wrap.appendChild(btns);
      anchor.appendChild(wrap);
    }).catch(function () {
      item.removeAttribute('data-nc-fu');
    });
  }

  function scan() {
    var r = root(); if (!r) return;
    Array.prototype.forEach.call(r.querySelectorAll('.upcart-product-item'), processItem);
  }

  var t = null;
  function schedule() { clearTimeout(t); t = setTimeout(scan, 150); }

  function start() {
    var r = root(); if (!r) return false;
    try { new MutationObserver(schedule).observe(r, { childList: true, subtree: true }); } catch (e) {}
    ['upcartSubscribeCartLoaded', 'upcartSubscribeCartUpdated', 'upcartSubscribeCartOpened'].forEach(function (fn) {
      if (typeof window[fn] === 'function') { try { window[fn](schedule); } catch (e) {} }
    });
    schedule();
    return true;
  }

  var tries = 0;
  var poll = setInterval(function () {
    if (window.upcartDocumentOrShadowRoot && start()) { clearInterval(poll); return; }
    if (++tries > 100) clearInterval(poll);
  }, 300);
})();
